// import { canUseDOM } from 'exenv';

export function htmlSitemapIndexPageLoading(resp = {}, store = {}) {
  return {
    type: 'HTML_SITEMAP_INDEX_PAGE_LOADING',
    htmlSitemapIndexPage: resp,
    store
  };
}

export function htmlSitemapIndexPageLoaded(resp = {}, store = {}) {
  return {
    type: 'HTML_SITEMAP_INDEX_PAGE_LOADED',
    htmlSitemapIndexPage: resp,
    store
  };
}

export function htmlSitemapIndexPageLoadError(error, store = {}) {
  return {
    type: 'HTML_SITEMAP_INDEX_PAGE_ERROR',
    htmlSitemapIndexPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
